import React, { useCallback } from 'react';
import { shutdownReportsQuery } from '../../../../shared/api/queries';
import { SelectAndDownloadReports } from '../../../../../../components/SelectAndDownloadReports';
import request from '../../../../../../helpers/request';

const { useShutdownReports } = shutdownReportsQuery;

const DownloadReports = () => {
  const { data: reports } = useShutdownReports({
    staleTime: Infinity,
  });

  const fetchReport = useCallback(
    async (reportData) =>
      await request.get(
        reportData.url,
        {},
        `Не удалось получить данные для отчета ${reportData.name}`
      ),
    []
  );

  return (
    <SelectAndDownloadReports
      reports={reports}
      fetchReport={fetchReport}
    />
  );
};

export default DownloadReports;
